/** Shared layout styles for Cognitive Flows dashboard (workflows / runs / contexts). */
export const dashboardStyles = {
    page: { height: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg)' },
    header: {
        width: '100%',
        background: '#ffffff', border: '1px solid #e9ecef',
        padding: '20px 24px', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', borderRadius: '12px',
        boxShadow: '0 8px 20px rgba(24, 39, 75, 0.04)',
        marginBottom: '24px',
        flexShrink: 0,
    },
    logo: { fontSize: '18px', fontWeight: 700, color: 'var(--primary)' },
    headerRight: { display: 'flex', alignItems: 'center', gap: '16px' },
    credits: {
        fontSize: '13px', fontWeight: 600, color: 'var(--primary)',
        background: 'var(--accent-light)', padding: '5px 12px',
        borderRadius: '99px', border: '1px solid #bfdbfe',
    },
    btnGhost: {
        background: 'none', border: '1px solid var(--border)', borderRadius: 'var(--radius)',
        padding: '7px 14px', fontSize: '13px', fontWeight: 500, color: 'var(--text-primary)',
        cursor: 'pointer',
    },
    btnPrimary: {
        background: 'var(--primary)', border: '1px solid var(--primary)',
        borderRadius: 'var(--radius)', padding: '8px 18px', fontSize: '13px',
        fontWeight: 500, color: '#fff', cursor: 'pointer',
    },
    main: { flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: '0', width: '100%' },
    sectionHead: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        marginBottom: '24px', flexWrap: 'wrap', gap: '12px',
        background: '#ffffff', border: '1px solid #e9ecef', borderRadius: '12px',
        padding: '20px 24px', boxShadow: '0 8px 20px rgba(24, 39, 75, 0.04)',
    },
    sectionTitle: { fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-primary)', margin: 0 },
    statsRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '18px', marginBottom: '24px' },
    statCard: {
        background: '#ffffff', border: '1px solid rgba(226, 232, 240, 0.8)', borderRadius: '16px',
        padding: '16px 20px', boxShadow: '0 12px 30px rgba(15, 23, 42, 0.05)', minHeight: '110px', display: 'flex', flexDirection: 'column', gap: '8px', justifyContent: 'flex-start',
    },
    statTitle: { fontSize: '11px', fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' },
    statValue: { fontSize: '2rem', fontWeight: 800, color: 'var(--text-primary)' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' },
    newCard: {
        background: 'var(--surface)', border: '2px dashed var(--border)',
        borderRadius: 'var(--radius-lg)', padding: '32px', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: '12px', cursor: 'pointer', minHeight: '160px', transition: 'border-color 0.15s',
    },
    newCardIcon: { fontSize: '28px', color: 'var(--text-muted)' },
    newCardLabel: { fontSize: '14px', fontWeight: 500, color: 'var(--text-secondary)' },
    empty: { textAlign: 'center', padding: '60px 0', color: 'var(--text-muted)' },
};
